import { render, staticRenderFns } from "./AddMorakhasi.vue?vue&type=template&id=48c65fa1&scoped=true&"
import script from "./AddMorakhasi.vue?vue&type=script&lang=js&"
export * from "./AddMorakhasi.vue?vue&type=script&lang=js&"
import style0 from "./AddMorakhasi.vue?vue&type=style&index=0&id=48c65fa1&scoped=true&lang=css&"
import style1 from "./AddMorakhasi.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c65fa1",
  null
  
)

export default component.exports